export const OrderItemType = {
  Product: 'product',
  Fee: 'fee',
} as const;

export type OrderItemTypeValue = (typeof OrderItemType)[keyof typeof OrderItemType];

export interface OrderItem {
  id: string;
  name: string;
  price: string;
  quantity: number;
  description?: string;
  category?: 'physical' | 'digital';
  type?: OrderItemTypeValue;
}
